export default "__VITE_ASSET__Bsfsx3kK__"